/**
 * Single source of truth for "should the UI animate?".
 *
 * True only when the OS does not request reduced motion AND the user's
 * `animationsEnabled` preference is not turned off. Use it to gate every
 * framer-motion animation so motion-off users get instant, static rendering.
 */

import { useReducedMotion } from 'framer-motion';

import { useAuth } from '@/providers/AuthProvider';
import { useUserPreferences } from '@/hooks/useUserPreferences';

export function usePrefersMotion(): boolean {
  const reduced = useReducedMotion();
  const { isAuthenticated } = useAuth();
  // Reuses the preferences query the app already loads when authenticated
  // (gated so anonymous pages don't fire a request).
  const { data } = useUserPreferences(isAuthenticated);

  if (reduced) return false;
  return data?.animationsEnabled !== false;
}
